<div class="document-add" fxLayout="column" fxLayoutGap="15px" >

<div fxLayout="row" >

  <div  *ngIf="!addMode" fxFlex="20">
    <mat-form-field appearance="standard" class="view-select">
<!--      <mat-label>Widok</mat-label>-->
      <mat-select [formControl]="registrationsViewControl">
        <mat-option [value]="true">Aktywne</mat-option>
        <mat-option [value]="false">Archiwum</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="!addMode" class="h2" fxFlex="70">
      <h2>Zgłoszenia</h2>
  </div>

  <div *ngIf="addMode" class="h2" fxFlex="90">
    <h2>Dodaj zgłoszenie</h2>
  </div>

  <div *ngIf="!addMode" class="button-exit"  fxFlex="10" fxLayout="row">
    <button (click)="loadListData()" mat-icon-button color="primary" matTooltip="Odśwież"><mat-icon>refresh</mat-icon></button>
    <button (click)="addModeActive()" mat-icon-button color="primary" matTooltip="Dodaj"><mat-icon>add</mat-icon></button>
    <button (click)="closeDialog($event)" mat-icon-button color="warn" matTooltip="Wyjście"><mat-icon>cancel</mat-icon></button>
  </div>

  <div *ngIf="addMode" fxLayout="row" fxFlex="10" class="button-exit" >
    <button (click)="sendForm()"  mat-icon-button color="primary" matTooltip="Wyślij"><mat-icon>send</mat-icon></button>
    <button (click)="addModeDisabled()" mat-icon-button color="warn" matTooltip="Anuluj"><mat-icon>cancel</mat-icon></button>
  </div>

</div>

  <div *ngIf="!addMode" fxLayout="column" fxFlex="100">
    <table mat-table [dataSource]="items" multiTemplateDataRows>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element">
          {{element.id}}
        </td>
      </ng-container>

      <ng-container matColumnDef="custom_id">
        <th mat-header-cell *matHeaderCellDef> Identyfikator </th>
        <td mat-cell *matCellDef="let element">
          {{element.custom_id}}
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef> Tytuł zgłoszenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.title}}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element">
          {{element.email}}
        </td>
      </ng-container>

      <ng-container matColumnDef="contents">
        <th mat-header-cell *matHeaderCellDef> Treść zgłoszenia </th>
        <td  colspan=3   mat-cell *matCellDef="let element">
          <span *ngIf="element.row" class="td" style="white-space: pre-line">{{element.contents}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="empty">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td     mat-cell *matCellDef="let element">
          <span *ngIf="element.row" class="td" style="white-space: pre-line"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">

          <button *ngIf="element.status==='odrzucone'" mat-raised-button [ngClass]="'negative-button'">{{element.status}}</button>
          <button *ngIf="element.status==='zgłoszone'  " mat-raised-button [ngClass]="'neutral-button'">{{element.status}}</button>
          <button *ngIf="element.status==='oczekujące' " mat-raised-button [ngClass]="'warning-button'">{{element.status}}</button>
          <button *ngIf=" element.status==='w trakcie realizacji' " mat-raised-button  [ngClass]="'positive-button'">{{element.status}}</button>
          <button *ngIf=" element.status==='wdrożone na produkcję' " mat-raised-button  [ngClass]="'positive-button'">{{element.status}}</button>

        </td>
      </ng-container>

      <ng-container matColumnDef="attachment">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element">
<!--          <button (click)="addFile(element.id)" mat-icon-button color="primary"><mat-icon>attachment</mat-icon></button>-->
          <button *ngIf="!element.row" (click)="expend_more(element)" mat-icon-button color="primary"><mat-icon>expand_more</mat-icon></button>
          <button *ngIf="element.row" (click)="expend_less(element)" mat-icon-button color="primary"><mat-icon>expand_less</mat-icon></button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>
      <tr  mat-row *matRowDef=" let row; columns: ['empty','contents','empty'];" class="expanded-data-row"></tr>


    </table>
  </div>

  <div *ngIf="addMode" fxLayout="column" fxFlex="100">
    <div fxLayout="row" fxLayoutGap="15px" >
    <mat-form-field fxFlex="24">
      <mat-label>Typ zgłoszenia</mat-label>
      <mat-select [formControl]="requestTypeControl">
        <mat-option *ngFor="let request of requests" [value]="request.value">
          {{request.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

      <mat-form-field fxFlex="24">
        <mat-label>System</mat-label>
        <mat-select [formControl]="typeControl">
          <mat-option *ngFor="let typ of type" [value]="typ.value">
            {{typ.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <mat-form-field fxFlex="24" *ngIf="module">
      <mat-label>Moduł zgłoszenia</mat-label>

      <mat-select [formControl]="reportingModuleControl" >
        <mat-option *ngFor="let reporting of reportings" [value]="reporting.value">
          {{reporting.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

      <mat-form-field fxFlex="24">
        <mat-label>Priorytet</mat-label>
        <mat-select [formControl]="priorityControl">
          <mat-option [value]="2">Wysoki</mat-option>
          <mat-option [value]="3">Normalny</mat-option>
          <mat-option [value]="4">Niski</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <form class="example-form">

      <mat-form-field class="example-full-width">
        <mat-label>Tytuł zgłoszenia</mat-label>
        <input [formControl]="titleControl" matInput placeholder="Tytuł" >
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Treść zgłoszenia</mat-label>
        <textarea  [formControl]="contentsControl"  matInput placeholder="Treść" rows="10" autofocus ></textarea>
      </mat-form-field>

    </form>
  </div>
</div>
